module.exports = __webpack_public_path__ + "img/behance-network.80c06545.svg";